module.exports = __webpack_public_path__ + "img/Bagan.a3ac2c37.png";